// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 847) return "static/chunks/a18f0e56-272654971375ac56.js";
	if (chunkId === 928) return "static/chunks/928-28bed4f752b9c4b8.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"b3b543dc8eea7b89","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"25fa397deb3654a9","367":"b9e466ee58bf94c7","639":"a79b6634a4f89da0","748":"4788ec9b560553b0"}[chunkId] + ".js";
};